import React from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {UserManagementsModuleIcon, CircleIcon} from '@src/assets/icons'

export const userNavigation =  [
    {
        id: 'userModule',
        title: 'user.nav.userManagement',
        icon: <FontAwesomeIcon icon={UserManagementsModuleIcon}/>,
        children: [
            {
                id: 'userList',
                title: 'user.nav.userList',
                icon: <FontAwesomeIcon icon={CircleIcon}/>,
                navLink: '/user/list',
                action: 'call',
                resource: 'USR_VIEW_USER_LIST|USR_MANAGE_USER'
            },
            {
                id: 'userGroup',
                title: 'user.nav.userGroup',
                icon: <FontAwesomeIcon icon={CircleIcon}/>,
                navLink: '/group/list',
                action: 'call',
                resource: 'USR_VIEW_GROUP_LIST|USR_MANAGE_GROUP'
            },
            {
                id: 'userRole',
                title: 'user.nav.userRole',
                icon: <FontAwesomeIcon icon={CircleIcon}/>,
                navLink: '/user/role',
                action: 'call',
                resource: 'USR_MANAGE_ROLE'
            }
        ]
    }
]
